module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epigraph.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Story-5"
  }, [_c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Healing is a matter of time,"), _c('br'), _vm._v("but it is sometimes also a matter of opportunity.")]), _vm._v(" "), _c('p', {
    staticClass: "citation"
  }, [_vm._v("~Hippocrates")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226c2c02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epigraph.vue
// module id = 75
// module chunks = 0